import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LaunchTree from '../components/LaunchTree';
import SpendingTree from '../components/SpendingTree';
import InteractiveTree from '../components/InteractiveTree';
import Diamond from '../components/Diamond';

/**
 * TreePage - Standalone page wrapper for individual decision trees
 * Enables deep linking to specific trees (e.g., /tree/launch)
 */
const TreePage = () => {
  const { treeId } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  // Render the appropriate tree based on the URL parameter
  const renderTree = () => {
    switch (treeId) {
      case 'launch':
        return <LaunchTree onClose={handleClose} />;
      case 'spending':
        return <SpendingTree onClose={handleClose} />;
      case 'intro':
        return (
          <div className="tree-page-wrapper">
            <div className="tree-page-container">
              <button className="tree-page-close" onClick={handleClose} aria-label="Close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
              <div className="tree-page-header">
                <h1 className="tree-page-title">
                  <Diamond color="#0057FF" size="md" /> Binary Game Introduction
                </h1>
                <p className="tree-page-subtitle">INTERACTIVE DECISION TREE</p>
              </div>
              <div className="tree-page-content">
                <InteractiveTree />
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="tree-page-not-found">
            <h1>Tree not found</h1>
            <p>The decision tree "{treeId}" does not exist.</p>
            <button onClick={handleClose} className="tree-page-back-btn">
              <Diamond color="#FFFFFF" size="xs" />
              Back to Home
            </button>
          </div>
        );
    }
  };

  return renderTree();
};

export default TreePage;
